import React, { useEffect, useState } from 'react';
import { Field, FormSpy } from 'react-final-form';
import { Row, Col } from 'reactstrap';
import Select from 'react-select';
import { FieldArray } from "react-final-form-arrays"
import CheckboxGroup from "@/shared/components/form/CheckboxGroup"
import CheckboxField from '@/shared/components/form/CheckBox';
import FieldUserStatus from './FieldUserStatus'
import renderSelectField from '@/shared/components/form/Select'
import axios from 'axios'
import getCountries from "@/service/getCountries";
import {labelizeNamedData, labelizeNamedRow} from '@/shared/helpers'
import renderToggleButtonField from "@/shared/components/form/ToggleButton";

const defaultConfig = {
  roles: [],
  roleInput: 'checkbox',
  roleField: 'roles',
  rolePlaceholder: 'Select Role',
  roleDisable: false,
  isProgram: false,
  unitNumberField: 'unit_number',
  unitNumberOptions: [],
  positionLevelField: 'position_level',
  positionLevelOptions: []
}

const prepareMonthList = () => {
  let list = [];
  for (var i = 1; i <= 12; i++) {
    list.push({ label: i, value: String(i).padStart(2, '0') })
  }
  return list;
}

const prepareDayList = () => {
  let list = [];
  for (var i = 1; i <= 31; i++) {
    list.push({ label: i, value: String(i).padStart(2, '0') })
  }
  return list;
}

const FormFields = ({ form, values, submitting, pristine, program, config }) => {
  config = { ...defaultConfig, ...config }
  // console.log(config)
  const [isSendInvite, setIsSendInvite] = useState(false)
  const [awardLevels, setAwardLevels] = useState([]);
  const [initialAwardLevel, setInitialAwardLevel] = useState(null);
  const [countries, setCountries] = React.useState([]);

  const MONTH_LIST = prepareMonthList()
  const DAY_LIST = prepareDayList()
  // console.log(onChangeActive)
  const onChangeSendInvite = (checked) => {
    setIsSendInvite(checked)
  }

  useEffect(() => {
    if (countries.length === 0) {
      getCountries()
        .then(result => {
          setCountries(labelizeNamedData(result))
        })
    }
  },)

  useEffect(() => {
    if(program && program.use_award_levels){
    if (program && program.organization_id && program.id) {
      getDataAwardLevels();
    }
    if (!values.award_level) {
      setInitialAwardLevel(values.award_level || null);
    }
    }
  }, [program, values.award_level]);

  const getDataAwardLevels = async () => {
    // Check if necessary IDs are available
    if (program.organization_id && program.id) {
      try {
        const response = await axios.get(
          `/organization/${program.organization_id}/program/${program.id}/program-award-levels`
        );
        const options = response.data.map(level => ({
          label: level.name,
          value: level.id,
          id: level.id,
        }));
        setAwardLevels(options);

        // Pre-select current award level using award_level_id returned by API
        const currentId = values.award_level_id || null;
        if (currentId) {
          const match = options.find(o => o.value === currentId);
          if (match) {
            form.change('award_level', match);
          }
        }
      } catch (error) {
        console.error('Failed to fetch award levels:', error);
      }
    }
  };


  const onChangeUnitNumber = () => {
    // console.log("On change unit number")
  }

  const onChangeAdminRole = (e) => {
    console.log(e)
    console.log("On change Org Admin Role")
  }

  return (
    <div className="user-form-fields w100">
      <Row>
        <Col md="6" lg="4" xl="4">
          <Field name="first_name">
            {({ input, meta }) => (
              <div className="form__form-group">
                <span className="form__form-group-label">First Name</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <input type="text" {...input} placeholder="First Name" />
                    {meta.touched && meta.error && (
                      <span className="form__form-group-error">
                        {meta.error}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Field>
        </Col>
        <Col md="6" lg="4" xl="4">
          <Field name="last_name">
            {({ input, meta }) => (
              <div className="form__form-group">
                <span className="form__form-group-label">Last Name</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <input type="text" {...input} placeholder="Last Name" />
                    {meta.touched && meta.error && (
                      <span className="form__form-group-error">
                        {meta.error}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Field>
        </Col>
        <Col md="6" lg="4" xl="4">
            <FormSpy subscription={{ values: true }}>
            {({ values }) => {
                const isLocked = Number(values?.is_locked) === 1;
                return (
                <div className="form__form-group" style={{ textAlign: "right" }}>
                    <span
                    className="form__form-group-label"
                    style={{
                        color: isLocked ? "#4ce1b6" : "#c0392b", // normal when locked, red when unlocked
                        
                    }}
                    >
                    {isLocked ? "Unlock User Account" : "Lock User Account"}
                    </span>
                    <div className="form__form-group-field">
                        <div className="form__form-group-row">
                            <Field
                            name="is_locked"
                            component={renderToggleButtonField}
                            className="toggle-btn-auto-width"
                            />
                        </div>
                    </div>
                </div>
                );
            }}
            </FormSpy>
        </Col>
      </Row>
      <Row>
        {!config.roleDisable && config.roles.length > 0 && (
          <Col md="6" lg="4" xl="4">
            <Field name={config.roleField}>
              {({ input, meta }) => (
                <div className="form__form-group">
                  <span className="form__form-group-label">Role</span>
                  <div className="form__form-group-field">
                    <div className="form__form-group-row">
                      {config.roleInput === "checkbox" && (
                        <FieldArray
                          component={CheckboxGroup}
                          options={config.roles}
                          {...input}
                        />
                      )}
                      {config.roleInput === "select" && (
                        <Select
                          options={config.roles}
                          clearable={false}
                          className="react-select"
                          placeholder={config.rolePlaceholder}
                          classNamePrefix="react-select"
                          {...input}
                        />
                      )}
                      {meta.touched && meta.error && (
                        <span className="form__form-group-error">
                          {meta.error}
                        </span>
                      )}
                    </div>
                  </div>
                  {/*{!config.isProgram && (<em>Program roles to be assigned within a Program</em>)}*/}
                </div>
              )}
            </Field>
            {program && program?.organization && <Field name={'is_organization_admin'}>
              {({ input, meta }) => (
                <div className="form__form-group">
                  <span className="form__form-group-label">Admin Roles</span>
                  <div className="form__form-group-field">
                    <div className="form__form-group-row">
                      <Field
                        name="is_organization_admin"
                        label={`Admin in "${program.organization.name}" org`}
                        type="checkbox"
                        component={CheckboxField}
                        parse={(value) => {
                          onChangeAdminRole(value);
                          return value;
                        }}
                      />
                      {meta.touched && meta.error && (
                        <span className="form__form-group-error">
                          {meta.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </Field>}
          </Col>
        )}
        <Col md="6" lg="4" xl="4">
          <FieldUserStatus />
        </Col>
        <Col md="6" lg="4" xl="4">
                       {/* Lock reason textarea (only when locked) */}
            <FormSpy subscription={{ values: true, initialValues: true }}>
                {({ values, initialValues }) => {

                    const wasAlreadyLocked = Number(initialValues?.is_locked) === 1;
                    const isLockedNow = Number(values?.is_locked) === 1;
                    // CASE 1: User already locked -> show message
                    if (wasAlreadyLocked && isLockedNow) {
                    return (
                        <div
                        className="mt-2"
                        style={{
                            fontSize: "13px",
                            color: "#c0392b",
                            background: "#fdecea",
                            padding: "8px",
                            borderRadius: "4px",
                            lineHeight: "1.4"
                        }}
                        >
                        <strong>User is locked for following reason:-</strong>
                        <div>{values.is_locked_reason}</div>
                        </div>
                    );
                    }

                    // CASE 2: User not locked yet but admin toggles ON -> show textarea
                    if (!wasAlreadyLocked && isLockedNow) {
                    return (
                        <div className="mt-2">
                        <Field name="is_locked_reason">
                            {({ input, meta }) => (
                            <div className="form__form-group">
                                <span className="form__form-group-label">
                                Reason for locking user account
                                </span>
                                <div className="form__form-group-field">
                                    <textarea
                                        {...input}
                                        rows="3"
                                        className="form-control"
                                        placeholder="Enter reason for locking this user..."
                                        onFocus={e => e.target.style.boxShadow = "none"}
                                    />
                                </div>
                                {meta.touched && meta.error && (
                                    <span className="form__form-group-error">
                                    {meta.error}
                                    </span>
                                )}
                            </div>
                            )}
                        </Field>
                        </div>
                    );
                    }

                    return null;
                }}
            </FormSpy>
        </Col>
      </Row>

      <Row>
        <Col md="6" lg="4" xl="4">
          <Field name="email">
            {({ input, meta }) => (
              <div className="form__form-group">
                <span className="form__form-group-label">Email</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <input type="text" {...input} placeholder="Email" />
                    {meta.touched && meta.error && (
                      <span className="form__form-group-error">
                        {meta.error}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Field>
        </Col>
        <Col md="6" lg="4" xl="4">
          <Field name="phone">
            {({ input, meta }) => (
              <div className="form__form-group">
                <span className="form__form-group-label">Phone Number</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <input
                      type="text"
                      {...input}
                      placeholder="Phone Number"
                    />
                    {meta.touched && meta.error && (
                      <span className="form__form-group-error">
                        {meta.error}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Field>
        </Col>
        <Col md="6" lg="4" xl="4">

          <Field name="countries">
            {({ input, meta }) => (
              <div className="form__form-group">
                <span className="form__form-group-label">Country</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <Field
                      name="country_id"
                      component={renderSelectField}
                      options={countries}
                    />
                    {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                  </div>
                </div>
              </div>
            )}
          </Field>

        </Col>
        {program?.uses_units > 0 && (
          <Col md="6" lg="4" xl="4">
            <div className="form__form-group">
              <span className="form__form-group-label">
                Unit Number
              </span>
              <div className="form__form-group-field">
                <div className="form__form-group-row">
                  <Field
                    name={config.unitNumberField}
                    options={config.unitNumberOptions}
                    component={renderSelectField}
                    parse={(value) => {
                      onChangeUnitNumber(value);
                      return value;
                    }}
                  />
                </div>
              </div>
            </div>
          </Col>
        )}
      </Row>
      <Row>
        
        <Col md="6" lg="4" xl="4">
        {Boolean(program?.use_award_levels) && (
          <Field name="award_level">
            {({ input, meta }) => (
              <div className="form__form-group">
                <span className="form__form-group-label">Award Level</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <Field
                      name="award_level"
                      component={renderSelectField}
                      options={awardLevels}
                    />
                    {meta.touched && meta.error && (
                      <span className="form__form-group-error">
                        {meta.error}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Field>
            )}
        </Col> 
       
        <Col md="6" lg="4" xl="4">
          <Field name="work_anniversary">
            {({ input, meta }) => (
              <div className="form__form-group">
                <span className="form__form-group-label">
                  Work Anniversary
                </span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <input
                      type="date"
                      {...input}
                      placeholder="Work Anniversary"
                    />
                    {meta.touched && meta.error && (
                      <span className="form__form-group-error">
                        {meta.error}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Field>
        </Col>
        <Col md="6" lg="4" xl="4">
          <div className='d-flex'>
            <div className="form__form-group">
              <span className="form__form-group-label">Birthday Month</span>
              <div className="form__form-group-field">
                <Field
                  name="month"
                  component={renderSelectField}
                  options={MONTH_LIST}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Day</span>
              <div className="form__form-group-field">
                <Field
                  name="day"
                  component={renderSelectField}
                  options={DAY_LIST}
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md="6" lg="4" xl="4">
          <Field name="division">
            {({ input, meta }) => (
              <div className="form__form-group">
                <span className="form__form-group-label">
                  Department / Team
                </span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <input
                      type="text"
                      {...input}
                      placeholder="Department / Team"
                    />
                    {meta.touched && meta.error && (
                      <span className="form__form-group-error">
                        {meta.error}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Field>
        </Col>
        <Col md="6" lg="4" xl="4">
          <Field name="employee_number">
            {({ input, meta }) => (
              <div className="form__form-group">
                <span className="form__form-group-label">
                  Employee Number
                </span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <input
                      type="text"
                      {...input}
                      placeholder="Employee Number"
                    />
                    {meta.touched && meta.error && (
                      <span className="form__form-group-error">
                        {meta.error}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Field>
        </Col>
        <Col md="6" lg="4" xl="4">
          <Field name="supervisor_employee_number">
            {({ input, meta }) => (
              <div className="form__form-group">
                <span className="form__form-group-label">Supervisor ID</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <input
                      type="text"
                      {...input}
                      placeholder="Supervisor ID"
                    />
                    {meta.touched && meta.error && (
                      <span className="form__form-group-error">
                        {meta.error}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Field>
        </Col>
      </Row>
      <Row>
        {(program?.use_budget_cascading > 0 || program?.use_cascading_approvals > 0) && (
          <Col md="6" lg="4" xl="4">
            <div className="form__form-group">
              <span className="form__form-group-label">
                Position Level
              </span>
              <div className="form__form-group-field">
                <div className="form__form-group-row">
                  <Field
                    name={config.positionLevelField}
                    options={config.positionLevelOptions}
                    component={renderSelectField}
                    parse={(value) => {
                      return value;
                    }}
                  />
                </div>
              </div>
            </div>
          </Col>
        )}
      </Row>
      <h4 className="mb-2">Password Settings:</h4>
      {config.isProgram && !values?.id && (
        <div className="form__form-group">
          <Field
            name="send_invite"
            label="Send Invite"
            type="checkbox"
            component={CheckboxField}
            parse={(value) => {
              onChangeSendInvite(value);
              return value;
            }}
          />
          {isSendInvite && (
            <label>User will set password for themselves</label>
          )}
        </div>
      )}
      {!isSendInvite && (
        <Row>
          <Col md="6" lg="4" xl="4">
            <Field name="password">
              {({ input, meta }) => (
                <div className="form__form-group">
                  <span className="form__form-group-label">Password</span>
                  <div className="form__form-group-field">
                    <div className="form__form-group-row">
                      <input
                        type="password"
                        {...input}
                        placeholder="password"
                      />
                      {meta.touched && meta.error && (
                        <span className="form__form-group-error">
                          {meta.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </Field>
          </Col>
          <Col md="6" lg="4" xl="4">
            <Field name="password_confirmation">
              {({ input, meta }) => (
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    Confirm Password
                  </span>
                  <div className="form__form-group-field">
                    <div className="form__form-group-row">
                      <input
                        type="password"
                        {...input}
                        placeholder="confirm password"
                      />
                      {meta.touched && meta.error && (
                        <span className="form__form-group-error">
                          {meta.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </Field>
          </Col>
          {values?.id && (
            <Col md="6" lg="4" xl="4">
              <Field
                name="force_password_reset"
                label="Force Password Reset"
                type="checkbox"
                component={CheckboxField}
              />
            </Col>
          )}
        </Row>
      )}
    </div>
  );
}

export default FormFields